import axios from 'axios';
import { IContactFormData } from '../../components/core/Footer/interfaces';

export enum AgreementValue {
  true = 'Checked',
  false = 'Not Checked',
}

export enum NDAValue {
  true = 'Yes',
  false = 'No',
}

export const submit_hubspot_form = async ({
  agreement,
  details,
  email,
  firstname,
  lastname,
  nda,
}: IContactFormData) => {
  const portalId = '9219940';
  const formGuid = '4fabbbda-753b-4769-bb5e-d7406ac87cf1';
  const config = {
    headers: {
      'Content-Type': 'application/json',
    },
  };

  const response = await axios.post(
    `https://api.hsforms.com/submissions/v3/integration/submit/${portalId}/${formGuid}`,
    {
      portalId,
      formGuid,
      fields: [
        {
          name: 'firstname',
          value: firstname,
        },
        {
          name: 'lastname',
          value: lastname,
        },
        {
          name: 'email',
          value: email,
        },
        {
          name: 'details',
          value: details,
        },
        {
          name: 'agreement',
          value:
            AgreementValue[agreement as unknown as keyof typeof AgreementValue],
        },
        {
          name: 'nda',
          value: NDAValue[nda as unknown as keyof typeof NDAValue],
        },
      ],
      context: { pageUri: 'www.qodeca.com' },
    },
    config
  );

  return response;
};
